"use strict";

jQuery( function ($) {

    window.addCustomInputStyles = function(specific_buttons) {
    
        if( specific_buttons ) {
            // only update payment buttons
            if( specific_buttons === "payment-buttons" ) {
                $( '.woocommerce-checkout .payment_box fieldset div img' ).attr( 'style', '' );
            }
        } else {
    
            // custom checkboxes
            if( $( 'input[type="checkbox"]' ).length ) {
                $( 'input[type="checkbox"]' ).each( function() {
                    if ($(this).next('span').length || ($(this).next('label').length && !$(this).next('label').hasClass('newsletter-inline-optin-label'))) {
                        return;
                    }
    
                    $( this ).addClass( 'checkbox-custom' );
                    $( '<span class="checkbox-button"></span>' ).insertAfter( this );
                });
    
                $( 'span.checkbox-button' ).on( 'click', function() {
                    var checkboxbutton = $( this ).prev( 'input[type="checkbox"]' );
    
                    if( !checkboxbutton.parent( 'label' ).length ) {
                        $( checkboxbutton ).trigger( 'click' );
                    }
                } );
            }
    
            // custom radiobuttons
            if( $( 'input[type="radio"]' ).length ) {
    
                $( 'input[type="radio"]' ).each( function() {
                    if ($(this).next('span').length || $(this).next('label').length) {
                        return;
                    }
    
                    $( this ).addClass( 'radio-custom' );
                    $( '<span class="radio-button"></span>' ).insertAfter( this );
                });
    
                $( 'span.radio-button' ).on( 'click', function() {
                    var radiobutton = $( this ).prev( 'input[type="radio"]' );
                    $( radiobutton ).prop( 'checked', true );
                    $( radiobutton ).trigger( 'change' );
                    $( radiobutton ).trigger( 'click' );
                } );
            }
        }
    }

    window.addCustomInputStyles();
});